import { convertToDateTime } from '@reg/shared/helper/dateTime-helper';

/**
 * Model to hold a body assessment's weight loss for a given day
 */
export class IdentityDailyWeightLoss {
    public dayName: string;
    public date: Date;
    public actualWeights: number[] = [];
    public targetWeight: number;
    public minWeight: number;
    public maxWeight: number;
    public weightDiff: number;
    public bodyFatPercentage: number;
    public isEligible: boolean;
    public ineligibleStartDateTime: Date;
    public ineligibleEndDateTime: Date;
    public isToday: boolean;
    public isOverWeekOld: boolean;

    public clone(): IdentityDailyWeightLoss {
        const clone: IdentityDailyWeightLoss = new IdentityDailyWeightLoss();
        clone.dayName = this.dayName;
        clone.actualWeights = (this.actualWeights || []).map((w: number) => w);
        clone.targetWeight = this.targetWeight;
        clone.minWeight = this.minWeight;
        clone.maxWeight = this.maxWeight;
        clone.bodyFatPercentage = this.bodyFatPercentage;
        clone.weightDiff = this.weightDiff;
        clone.isEligible = this.isEligible;
        clone.isToday = this.isToday ?? null;
        clone.isOverWeekOld = this.isOverWeekOld ?? null;

        if (this.date) {
            clone.date = new Date(this.date.getTime());
        }
        if (this.ineligibleStartDateTime) {
            clone.ineligibleStartDateTime = new Date(this.ineligibleStartDateTime.getTime());
        }
        if (this.ineligibleEndDateTime) {
            clone.ineligibleEndDateTime = new Date(this.ineligibleEndDateTime.getTime());
        }

        return clone;
    }

    public deserialize(data: any): IdentityDailyWeightLoss {
        this.dayName = data['dayName'];
        this.date = convertToDateTime(data['date']);
        this.actualWeights = data['actualWeights'] || [];
        this.targetWeight = data['targetWeight'];
        this.minWeight = data['minWeight'];
        this.maxWeight = data['maxWeight'];
        this.weightDiff = data['weightDiff'];
        this.bodyFatPercentage = data['bodyFatPercentage'];
        this.isEligible = data['isEligible'];

        if (data['ineligibleStartDateTime']) {
            this.ineligibleStartDateTime = convertToDateTime(data['ineligibleStartDateTime']);
        }

        if (data['ineligibleEndDateTime']) {
            this.ineligibleEndDateTime = convertToDateTime(data['ineligibleEndDateTime']);
        }

        return this;
    }
}
